module.exports = __webpack_public_path__ + "static/img/perfil.2fbaccf8.jpg";